import React, { useState, useEffect, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Actions
import { gameActions } from '../../actions';

// Helpers
import { socketOn } from '../../helpers/sockets';

import Header from '../../components/Header';
import DebriefTabs from './debrief_tabs';
// import { DebriefMenu } from './debrief_menu';

// Methods
const importView = (mini_sim_id) =>
  lazy(() =>
    import(`../catalog/sims/mini_sim_${mini_sim_id}_debrief`).catch(() =>
      import(`../catalog/sims/mini_sim_0`)
    )
  );

const Debrief = () => {
  // State
  const [LoadedSimComponent, setLoadedSimComponent] = useState(null);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { sim_id } = game?.data || {};
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (id) {
      dispatch(gameActions.fetchGames(id));
      socketOn('result', (data) => {
        console.log('Receiving result', data);
        setShouldRefresh(true);
      });
    }
  }, [dispatch, id]);

  // Effects
  useEffect(() => {
    const loadViews = async () => {
      const componentPromise = await importView(sim_id);
      setLoadedSimComponent(componentPromise);
    };
    loadViews();
  }, [sim_id]);

  return (
    <div>
      <Header />

      <div className='d-flex align-items-end my-4'>
        <div className='me-auto'>
          {/* Setup and Debrief buttons/tabs */}
          {game.data && <DebriefTabs game_id={game.data._id} />}

          {/* Display refresh message when new data is available */}
          {shouldRefresh && (
            <button
              className='btn btn-sm btn-link ms-2'
              onClick={() => {
                setShouldRefresh(false);
                dispatch(gameActions.fetchGames(id));
              }}>
              New data available: Click to reload
            </button>
          )}
        </div>
      </div>

      <div className='row pb-2 mb-5'>
        {/* Dynamic Debrief: Mini-Sim-Specific */}
        <div className='col-8 offset-2'>
          {LoadedSimComponent && (
            <div
              id='debrief-container'
              className='d-flex flex-column justify-content-center align-items-center flex-grow-1'>
              <LoadedSimComponent {...game?.data} />
            </div>
          )}
        </div>
        {/* Extended Analysis */}
        {/* <div className='col-6'>
          <div className='card shadow overflow-hidden h-100x mb-4'>
            <div className='card-body'>
              <p className='fw-bold'>Individual Player Outcomes</p>
              ...
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export { Debrief as GameDebrief };
